import { rootApi } from "../../api/rootApi";

export const adminAuthApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchAllAppUserType: builder.query({
            query: (params) => ({
                method: 'GET',
                url: '/admin/appUserType',
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + params.token,
                },
            })
        }),
        addAppUsersType: builder.mutation({
            query: (params) => ({
                method: 'POST',
                url: '/admin/appUserType/add',
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + params.token,
                },
                body: params.body
            })
        }),
        fetchTenantAppUserTypes: builder.query({
            query: (params) => ({
                method: 'GET',
                url: '/tenant/appUserType/list',
                headers: {
                    Authorization: "Bearer " + params.token,
                    slug: params.slug
                }
            })
        }),
        addTenantAppUserType: builder.mutation({
            query: (params) => ({
                method: 'POST',
                url: '/tenant/appUserType/add',
                headers: {
                    Authorization: "Bearer " + params.token,
                    slug: params.slug
                },
                body: params.body
            })
        }),
        updateTenantAppUserType: builder.mutation({
            query: (params) => ({
                method: 'PUT',
                url: `/tenant/appUserType/update-detail/${params.id}`,
                headers: {
                    Authorization: "Bearer " + params.token,
                    slug: params.slug
                },
                body: params.body
            })
        }),
    })
});

export const {
    useFetchAllAppUserTypeQuery,
    useFetchTenantAppUserTypesQuery,
    useAddTenantAppUserTypeMutation,
    useUpdateTenantAppUserTypeMutation
} = adminAuthApi;